(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosa-barra-horizontal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rosa-mensajes')) customElements.define('rosa-mensajes',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.querySelector('button')?.addEventListener('click',()=>{
        const paused=this.dataset.paused!=='true';
        this.dataset.paused=String(paused);
        const button=this.querySelector('button');
        button.setAttribute('aria-pressed',String(paused));
        button.setAttribute('aria-label',paused?this.dataset.play:this.dataset.pause);
        button.querySelector('span').textContent=paused?'▶':'Ⅱ';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rosa-producto"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rosa-producto')) customElements.define('rosa-producto', class extends HTMLElement {
    connectedCallback() {
      if (this.ready || !this.querySelector('[data-rosa-config]')) return;
      this.ready = true;
      this.config = JSON.parse(this.querySelector('[data-rosa-config]').textContent);
      this.words = this.querySelector('[data-rosa-messages]').dataset;
      this.money = value => new Intl.NumberFormat('es-MX', {style:'currency', currency:this.config.currency,currencyDisplay:'narrowSymbol'}).format(value / 100) + ' ' + this.config.currency;
      this.root = this.config.root.replace(/\/?$/, '/');
      this.form = this.querySelector('[data-bundle-form]');
      this.add = this.querySelector('[data-add]');
      this.error = this.querySelector('[data-error]');
      this.busy = false;
      this.querySelectorAll('[data-tier]').forEach(tier => this.makeRows(tier));
      this.form?.addEventListener('change', () => this.refresh());
      this.querySelector('[data-gift-check]')?.addEventListener('change', () => this.refresh());
      this.form?.addEventListener('submit', event => { event.preventDefault(); this.submitBundle(); });
      this.querySelectorAll('[data-show-media]').forEach(button => button.addEventListener('click', () => this.showMedia(button.dataset.showMedia)));
      this.refresh();
      this.openAtProduct();
    }
    openAtProduct() {
      if (!this.hasAttribute('data-open-at-product') || window.Shopify?.designMode || window.location.hash) return;
      if (performance.getEntriesByType('navigation')[0]?.type === 'back_forward') return;
      const events = ['pointerdown', 'touchstart', 'wheel', 'keydown'];
      const controller = new AbortController();
      const cancel = () => controller.abort();
      events.forEach(type => window.addEventListener(type, cancel, {once:true, passive:true, signal:controller.signal}));
      const enter = () => {
        if (controller.signal.aborted) return;
        controller.abort();
        if (!this.isConnected || window.location.hash || window.scrollY > 0) return;
        this.scrollIntoView({behavior:'instant', block:'start'});
      };
      const ready = () => requestAnimationFrame(() => requestAnimationFrame(enter));
      if (document.readyState === 'complete') ready();
      else {
        window.addEventListener('load', ready, {once:true, signal:controller.signal});
        const deadline = window.setTimeout(ready, 1800);
        controller.signal.addEventListener('abort', () => window.clearTimeout(deadline), {once:true});
      }
    }
    showMedia(id) {
      this.querySelectorAll('[data-media]').forEach(slide => {slide.hidden = slide.dataset.media !== String(id); if (slide.hidden) slide.querySelectorAll('video').forEach(v=>v.pause());});
      this.querySelectorAll('[data-show-media]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.showMedia === String(id))));
    }
    makeRows(tier) {
      const first = this.config.variants.find(v=>v.available) || this.config.variants[0];
      for(let i=0;i<Number(tier.dataset.tier);i++) {
        const row = this.querySelector('[data-row-template]').content.firstElementChild.cloneNode(true);
        row.querySelector('[data-piece-number]').textContent = '#' + (i+1);
        row.querySelectorAll('[data-option]').forEach(select => {select.value = first.options[Number(select.dataset.option)];});
        const updateImage=()=>{const variant=this.variantFor(row);const image=row.querySelector('img');if(variant?.featured_image?.src&&image){image.src=variant.featured_image.src;image.removeAttribute('srcset');}};
        row.addEventListener('change',updateImage);updateImage();
        tier.querySelector('[data-rows]').append(row);
      }
    }
    variantFor(row) {
      const selected=[];row.querySelectorAll('[data-option]').forEach(select=>{selected[Number(select.dataset.option)]=select.value;});
      return this.config.variants.find(v=>selected.length === 0 || v.options.every((value,index)=>value === selected[index]));
    }
    selectedGift() {const selected=[];this.querySelectorAll('[data-gift-option]').forEach(select=>{selected[Number(select.dataset.giftOption)]=select.value;});return this.config.giftVariants.find(v=>v.options.every((value,index)=>value===selected[index]));}
    current() { return this.querySelector('[data-tier]:has(input[type=radio]:checked)'); }
    selectedVariants(tier) {return [...tier.querySelectorAll('.rosa-bundle__row')].map(row=>this.variantFor(row));}
    expectedPrice(variants, quantity) {
      const sorted=variants.map(v=>v.price).sort((a,b)=>b-a);
      const paid=quantity === 5 ? 3 : quantity === 3 ? 2 : 1;
      return sorted.slice(0,paid).reduce((sum,price)=>sum+price,0);
    }
    refresh() {
      if(!this.form)return;
      const chosen=this.current();
      const quantity=Number(chosen.dataset.tier);
      let valid=true;
      this.querySelectorAll('[data-tier]').forEach(tier=>{
        const selected=tier === chosen;
        tier.querySelector('[data-rows]').hidden=!selected;
        const variants=this.selectedVariants(tier);
        tier.querySelectorAll('.rosa-bundle__row').forEach((row,index)=>{const ok=!!variants[index]?.available;row.querySelector('[data-row-error]').hidden=ok;if(selected&&!ok)valid=false;});
        if(variants.every(Boolean)) {
          tier.querySelector('[data-tier-price]').textContent=this.money(this.expectedPrice(variants,Number(tier.dataset.tier)));
          const compare=tier.querySelector('[data-tier-compare]');if(compare)compare.textContent=this.money(variants.reduce((s,v)=>s+v.price,0));
        }
      });
      const gift=this.querySelector('[data-gift]');
      if(gift){
        gift.hidden=quantity<3;
        chosen.append(gift);
        const check=gift.querySelector('[data-gift-check]');
        check.disabled=quantity<3;
        if(check.disabled)check.checked=false;
        gift.querySelector('.rosa-gift__variants').hidden=!check.checked;
        gift.querySelector('[data-gift-toggle-label]').textContent=check.checked?this.words.giftAdded:this.words.giftAdd;
        const variant=this.selectedGift();
        if(check.checked)valid=valid&&!!variant?.available;
        const image=gift.querySelector('img');if(variant?.featured_image?.src&&image){image.src=variant.featured_image.src;image.removeAttribute('srcset');}
        if(variant)gift.querySelector('[data-gift-price]').textContent=this.money(variant.price);
      }
      const pending=quantity>1&&(!this.config.promotionReady||(this.querySelector('[data-gift-check]')?.checked&&!this.config.giftReady));
      this.querySelector('[data-offer-notice]').hidden=!pending;
      this.add.disabled=this.busy||pending||!valid;
      this.add.textContent=this.busy?this.words.adding:pending?this.words.pending:!valid?this.words.soldOut:this.words.add;
    }
    async request(path, body) {
      const response=await fetch(this.root+path,{method:body?'POST':'GET',headers:{'Content-Type':'application/json','Accept':'application/json'},...(body?{body:JSON.stringify(body)}:{})});
      const result=await response.json();
      if(!response.ok||result.status>=400)throw new Error(typeof result.description==='string'?result.description:this.words.error);
      return result;
    }
    async submitBundle() {
      if(this.busy||this.add.disabled)return;
      const tier=this.current(), quantity=Number(tier.dataset.tier),variants=this.selectedVariants(tier);
      const token='rosa-'+Date.now()+'-'+Math.random().toString(36).slice(2,9);
      const items=variants.map(v=>({id:v.id,quantity:1,properties:{_rosa_bundle:token}}));
      const includeGift=quantity>1&&this.querySelector('[data-gift-check]')?.checked&&this.config.giftReady;
      if(includeGift)items.push({id:this.selectedGift().id,quantity:1,properties:{_rosa_bundle:token,_rosa_gift:'1'}});
      this.busy=true;this.error.hidden=true;this.refresh();
      let added=false;
      try {
        await this.request('cart/add.js',{items});added=true;
        const code=quantity===3?this.config.codeThree:quantity===5?this.config.codeFive:'';
        const requested=[code,includeGift?this.config.giftCode:''].filter(Boolean);
        if(requested.length){const previous=await this.request('cart.js');const existing=(previous.discount_codes||[]).filter(d=>d.applicable).map(d=>d.code);await this.request('cart/update.js',{discount:[...new Set([...existing,...requested])].join(',')});}
        const cart=await this.request('cart.js');
        const ourItems=cart.items.filter(item=>item.properties?._rosa_bundle===token);
        const total=ourItems.reduce((sum,item)=>sum+item.final_line_price,0);
        const giftPaid=ourItems.some(item=>item.properties?._rosa_gift==='1'&&item.final_line_price>0);
        if(quantity>1&&(total>this.expectedPrice(variants,quantity)||giftPaid)) {
          await this.request('cart/update.js',{updates:Object.fromEntries(ourItems.map(item=>[item.key,0]))});
          added=false;throw new Error(this.words.discountError);
        }
        this.querySelector('[data-status]').textContent=this.words.success;
        const drawer=document.querySelector('cart-drawer');
        if(drawer&&typeof drawer.renderContents==='function'){
          try {
            const sections=await this.request('cart/update.js',{updates:{},sections:['cart-drawer','cart-icon-bubble'],sections_url:window.location.pathname});
            if(!sections.sections?.['cart-drawer'])throw new Error('sections');
            drawer.renderContents(sections);drawer.classList.remove('is-empty');if(typeof drawer.open==='function')drawer.open();
          }catch{window.location.assign(this.root+'cart');}
        }else{window.location.assign(this.root+'cart');}
      }catch(error){this.error.textContent=(added?this.words.checkCart+' ': '')+(error.message||this.words.error);this.error.hidden=false;}
      finally{this.busy=false;this.refresh();}
    }
  });

  } catch(e) { console.error(e); }
})();
})();
